export const items = [
    {
        src: "https://static.wixstatic.com/media/e49d9d_b4bb9b8de4cf4afba3589a19e2bfbb66~mv2.png",
        title: "Store banne traditionnel",
        url: "/store/banne-traditionnel",
    },
    {
        src: "https://static.wixstatic.com/media/e49d9d_890ccd604f7c46319caa0bd11f15306b~mv2.png",
        title: "Store banne coffre",
        url: "/store/banne-coffre",
    },
    {
        src: "https://static.wixstatic.com/media/e49d9d_78c33bcf37a148f8afedf1fb875270a4~mv2.jpg",
        title: "Store Pantographe",
        url: "/store/pantographe-croisillons",
    },
    {
        src: "https://static.wixstatic.com/media/e49d9d_b87b8fd37d16414ba2d0bbb1f9140eec~mv2.png",
        title: "Store corbeille",
        url: "/store/corbeille",
    },
    {
        src: "https://static.wixstatic.com/media/e49d9d_a5baa3c1048f4bb3be669a3e8b687348~mv2.png",
        title: "Store de jardin",
        url: "/store/de-jardin",
    },
    {
        src: "https://static.wixstatic.com/media/e49d9d_d1ae89f415744bc7b558a73b0b4f34b2~mv2.jpg",
        title: "Store à projection (à l'italienne)",
        url: "/store/projection-a-l-italienne",
    },
]